// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useInstruments } from '@hooks/other/useInstruments';
import { useMemo } from 'react';
import { CollateralAgreement } from '@daml.js/utility-collateral-app-v2/lib/Utility/Collateral/App/Model/Collateral';
import TemplateContract from '../../../utils/TemplateContract';
import { createInstrumentKey } from '../../../utils/instrument';

type UseGetEligibleInstrumentsFromCollateralAgreementConfig = {
  collateralAgreement: TemplateContract<CollateralAgreement>;
};

export const useGetEligibleInstrumentsFromCollateralAgreement = ({
  collateralAgreement,
}: UseGetEligibleInstrumentsFromCollateralAgreementConfig) => {
  const { getInstrumentsByKeys } = useInstruments();

  return useMemo(() => {
    const collateralAgreementInstrumentKeys =
      collateralAgreement.payload.terms.eligibleCollateral.eligibleInstruments.map(
        ({ instrument }) => {
          return createInstrumentKey(instrument.id, instrument.admin);
        },
      );

    return getInstrumentsByKeys(collateralAgreementInstrumentKeys);
  }, [collateralAgreement, getInstrumentsByKeys]);
};
